import React from "react";
import styled from 'styled-components';
import { Section, Container } from '../../components/Section'
import FinancingCardIcon from '../../components/Icons/FinancingCardIcon';
import FinancingForm from '../../components/FinancingForm';

const Grid = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin:0 -15px;
`
const GridItem = styled.div`
	position:relative;
	width:100%;
	padding:0 15px;
	@media(min-width:992px){
		flex:0 0 50%;
		max-width:50%;
	}	
`
const Card = styled.div`
	position: relative;
	background: #f7f5f5;
	height:100%;
`
const Feature = styled.div`
	margin:0;
`
const FeatureItem = styled.div`
	display: flex;
	flex-wrap:nowrap;
	+ .feature-item{
		margin-top:20px;
	}
	.icon {
		width: 18px;
		height: 38px;
		display: flex;
		align-items: center;
		+ .text{
			margin-left:10px;
		}
	}
	h3 {
		text-align: left;
		color: #000;
		margin-bottom: 0;
	}
	p {
		color: #000;
		margin-bottom: 0;
	}
`
const CardBody = styled.div`
	padding:30px;
`
const CardTitle = styled.h2`
	color: #000;
`
const CardDesc = styled.div`
	position: relative;
	border-bottom: 1px solid #E43D3C;
	color: #000;
	padding-bottom: 15px;
	margin-bottom: 15px;
	p{
		margin-bottom:0;
	}
`

const BenefitSection = ({ data, formData }) => {
	return(
		<Section zIndex="2" pt="120px" pb="0" xpt="60px" xpb="0" mpt="40px" mpb="0">
			<Container>
				<Grid>
					<GridItem>
						<Card>
							<CardBody>
								<CardTitle color="#000">{data.title}</CardTitle>
								<CardDesc><p>{data.description}</p></CardDesc>
								<Feature className="feature">
									{
										data.benefits.map((item,i)=>(
											<FeatureItem className="feature-item" key={`benefit-${i}`}>
												<div className="icon"><FinancingCardIcon /></div>
												<div className="text">
													<h3>{item.title}</h3>
													<p>{item.description}</p>
												</div>
											</FeatureItem>
										))
									}
								</Feature>
							</CardBody>
						</Card>
					</GridItem>
					<GridItem>
						<Card className="form-wrap">
							<CardBody>
								<CardTitle color="#000">{formData.title}</CardTitle>
								<FinancingForm formData={formData} />
							</CardBody>
						</Card>
					</GridItem>
				</Grid>
			</Container>
		</Section>
	)
};

export default BenefitSection